import React, { useEffect, useLayoutEffect, useState } from "react";
import { Autocomplete, Box, Grid, IconButton, Modal, Pagination, TextField, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import AuthService from "../../Components/auth/AuthService";
import { useNavigate } from "react-router-dom";
import {
  hideLoading,
  showLoading,
  useLoadingDispatch,
} from "../../context/loadingContext";
import { Button, Table, DatePicker as AntDate } from "antd/es";
import { DeleteFilled, DownloadOutlined, EditFilled, PlusCircleFilled } from "@ant-design/icons";
// import DatePicker from "react-date-picker";
import { DATE_FORMAT, DEFAULT_DATE_FORMAT, discountStatus } from "../../Components/common/constants";
import Message from "../../Components/common/Message";
import DiscountModal from "../../Components/Modals/DiscountModal";
import config from "../../Components/config";
import dayjs from "dayjs";
import { showMessage } from "../../Components/Utils/message";
import { fetchFuelReport } from "../Services/ReportService";
import { fetchAllVehicles } from "../Services/ApiRequestService";
const useStyles = makeStyles((theme) => ({
  row: {
    cursor: "pointer",
  },
  tblTopDiv: {},
  tblsearch: {
    display: "flex",
    float: "left",
  },
  addIcon: {
    float: "right",
  },
  dateField: {
    width: "100%",
    marginRight: "10px",
    height: "40px",
    "& .react-date-picker__wrapper": {
      border: "thin solid #b6babf",
      borderRadius: '5px',
    }
  },
  antTable: {
    "& .ant-table-tbody > tr > td": {
      borderBottom: "1px solid #b7b9bd",
    },
  },
  antAddIcon: {
    "& .anticon-plus-circle:hover": {
      color: "#4096ff !important"
    }
  },
}));

const { RangePicker } = AntDate;

const Auth = new AuthService();

export default function FuelReport() {

  const classes = useStyles();
  const navigate = useNavigate();
  var layoutDispatch = useLoadingDispatch();

  const [page, setPage] = React.useState(1);
  const [pageChange, setPageChange] = React.useState(false);
  const [limit] = React.useState(50);
  const [totalPages, setTotalPages] = React.useState(0);
  const [totalCount, setTotalCount] = React.useState(null);

  const [loadMessage, setLoadMessage] = React.useState("");
  const [type, setType] = React.useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [allFuelRecords, setAllFuelRecords] = React.useState([]);
  const [allVehicle, setAllVehicle] = React.useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState("");

  const [dateRange, setDateRange] = useState(null);


  const fuelCol = [
    {
      title: 'Date',
      dataIndex: "fuel_date",
      key: "fuel_date",
      render: (date) => {
        return date ? dayjs(date).format(DATE_FORMAT) : null
      },
    },
    {
      title: 'Vehicle',
      render: (record) => {
        return record?.vehicle_id
          ? allVehicle.filter((obj) => obj.id == record.vehicle_id)[0]?.registration_number
          : ""
      },
    },
    {
      title: 'Volume',
      dataIndex: "volume",
      key: "volume",
    },
    {
      title: 'Unit Price',
      dataIndex: "unit_price",
      key: "unit_price",
    },
    {
      title: 'Total Price',
      render: (record) => {
        const totalPrice = record?.volume * record.unit_price
        return <>{`£ ${totalPrice.toFixed(2)}`}</>;
      },
    },
    {
      title: 'Fuel Type',
      render: (record) => {
        return record?.fuel_type == 1 ? 'Diesel' : 'Petrol'
      },
    },
    {
      title: 'Odometer',
      key: "odometer",
      dataIndex: "odometer"
    },
    {
      title: 'Fuel Tank',
      key: "fuel_tank",
      dataIndex: "fuel_tank"
    },
    {
      title: 'Vendor',
      key: "vendor",
      dataIndex: "vendor"
    },
  ];

  const search = async (download) => {
    let search = {};
    if (dateRange && dateRange[0]) search.start_date = dateRange[0].format(DEFAULT_DATE_FORMAT);
    if (dateRange && dateRange[1]) search.end_date = dateRange[1].format(DEFAULT_DATE_FORMAT);
    if (selectedVehicle) search.vehicle_id = selectedVehicle.id;
    if (page && pageChange) search.page = page;

    if (download) search.download = 1;

    try {
      const res = await fetchFuelReport(search)
      if (res?.ack) {
        if (download) {
          window.open(res.file_url, "_blank", "noreferrer");
        } else {
          setAllFuelRecords(res?.fuel_entries);
          setTotalPages(Math.ceil(res.total_count / limit));
          setTotalCount(res.total_count);
        }
      } else {
        setAllFuelRecords([]);
        setLoadMessage(res?.message)
        showMessage('error', res?.message)
      }
    } catch (err) {
      showMessage('error', 'something went wrong');
    } finally {
      hideLoading(layoutDispatch)
    }
  };

  const handleChange = (event, value) => {
    setPage(value);
    setPageChange(true)
  };

  useEffect(() => {
    const searchTimeout = setTimeout(() => search(), 1000);

    return () => {
      clearTimeout(searchTimeout);
    };
  }, [dateRange, selectedVehicle, page]);

  const getAllVehicles = async () => {
    showLoading(layoutDispatch);
    try {
      const response = await fetchAllVehicles();
      if (response) {
        hideLoading(layoutDispatch);
        if (response?.ack) {
          setAllVehicle(response.vehicles);
        }
      }
    } catch (err) {
      console.log(err);
    }
  }

  useLayoutEffect(() => {
    getAllVehicles()
  }, [])


  const updateFilters = (newValues) => {
    const existingFiltersString = localStorage.getItem('FuelFilters');
    let existingFilters = {};
    if (existingFiltersString) {
      try {
        existingFilters = JSON.parse(existingFiltersString);
      } catch (e) {
        console.error("Error parsing FuelFilters from localStorage", e);
      }
    }
    Object.assign(existingFilters, newValues);
    existingFilters.timestamp = new Date().getTime();
    const updatedFiltersString = JSON.stringify(existingFilters);
    localStorage.setItem('FuelFilters', updatedFiltersString);
  };

  const getFiltersOrDefault = () => {
    const existingFiltersString = localStorage.getItem('FuelFilters');
    let existingFilters = {};
    if (existingFiltersString) {
      try {
        existingFilters = JSON.parse(existingFiltersString);
      } catch (e) {
        console.error("Error parsing FuelFilters from localStorage", e);
      }
    }
    const currentTime = new Date().getTime();
    const expirationTime = 30 * 60 * 1000;
    if (existingFilters.timestamp && currentTime - existingFilters.timestamp < expirationTime) {

      if (!existingFilters.status) {
        existingFilters.status = '';
      }
      return existingFilters;
    } else {
      localStorage.removeItem('FuelFilters');
      return {};
    }
  };

  useEffect(() => {
    const initialState = getFiltersOrDefault();
    setSelectedVehicle(initialState?.vehicle);

    if (initialState?.dateRange && initialState.dateRange[0]) {
      setDateRange([dayjs(initialState.dateRange[0]), dayjs(initialState.dateRange[1])]);
    } else {
      const firstDayOfMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
      const lastDayOfMonth = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
      setDateRange([dayjs(firstDayOfMonth), dayjs(lastDayOfMonth)]);
      initialState.dateRange = [dayjs(firstDayOfMonth).format(DEFAULT_DATE_FORMAT), dayjs(lastDayOfMonth).format(DEFAULT_DATE_FORMAT)];
    }

    initialState.timestamp = new Date().getTime();
    updateFilters(initialState)
  }, []);

  return (
    <div>
      <h2 style={{ marginBottom: '10px', marginTop: 0 }}>Fuel Reports</h2>
      <Grid container rowSpacing={1} columnSpacing={1}>
        <Grid item xs={8}>
        </Grid>
        <Grid item xs={4}>
          <Button
            style={{ float: "right" }}
            type="primary"
            size='large'
            icon={<DownloadOutlined />}
            onClick={() => { search(1) }}
          >
            Download
          </Button>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={6} lg={4} xl={2}>
          <label htmlFor="pcnDate">Date:</label>
          <RangePicker
            format={DATE_FORMAT}
            style={{ width: '100%' }}
            size="large"
            value={dateRange}
            onChange={(dates) => {
              setDateRange(dates);
              updateFilters({
                dateRange: dates ? [dates[0].format(DEFAULT_DATE_FORMAT), dates[1].format(DEFAULT_DATE_FORMAT)] : null,
              });
              setPageChange(false)
              setPage(1)
            }}
            allowClear={true}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3} lg={2} xl={1.5}>
          <label htmlFor="route">Vehicle</label>
          <Autocomplete
            id="vehicles"
            size="small"
            options={allVehicle}
            getOptionLabel={(option) => option.registration_number ? option.registration_number : ''}
            value={selectedVehicle}
            onChange={(e, values) => {
              setSelectedVehicle(values);
              updateFilters({ vehicle: values });
              setPageChange(false)
              setPage(1)
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Vehicle"
              />
            )}
          />
        </Grid>
      </Grid>

      <div className={classes.antTable}>
        <Table
          columns={fuelCol}
          style={{ marginTop: '10px' }}
          scroll={{ x: 'max-content' }}
          pagination={false}
          // bordered
          dataSource={allFuelRecords}
          loading={isLoading}
          // footer={() => `List of Fuel Records - Total Records: ${allFuelRecords?.length === 0 ? "0" : allFuelRecords?.length}`}
          footer={() => {
            const startRecord = (page - 1) * limit + 1;
            const endRecord = Math.min(page * limit, allFuelRecords.length ? totalCount : 0);
            return `Showing ${startRecord}-${endRecord} of ${allFuelRecords.length ? totalCount : "0"} Records`;
          }}
        />
      </div>

      <div style={{ float: "right", margin: "10px" }}>
        <Pagination
          page={page}
          count={totalPages}
          variant="outlined"
          color="primary"
          onChange={handleChange}
        />
      </div>
      <Message type={type} msg={loadMessage} />
    </div>
  );
}
